import { readonly, ref, useContext } from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
function useExternalCheckout() {
  const { app } = useContext();
  const loading = ref(false);
  const error = ref(null);
  const initializeCheckout = (params) => {
    Logger.debug("[Magento]: Initialize external checkout", { params });
    try {
      const { externalCheckout, state } = app.context.$vsf.$magento.config;
      const userToken = state.getCustomerToken();
      const cartToken = state.getCartId();
      Logger.debug({ userToken, cartToken });
      loading.value = true;
      if (externalCheckout.enable) {
        if (userToken && cartToken) {
          window.location.replace(`${externalCheckout.cmsUrl}${externalCheckout.syncUrlPath}/token/${userToken}/cart/${cartToken}`);
          return "";
        }
        window.location.replace(`${externalCheckout.cmsUrl}${externalCheckout.syncUrlPath}/token//cart/${cartToken}`);
        return "";
      }
      return params.baseUrl;
    } catch (err) {
      error.value = err;
      Logger.error(err);
    } finally {
      loading.value = false;
    }
  };
  return {
    initializeCheckout,
    loading: readonly(loading),
    error: readonly(error)
  };
}
export * from "./useExternalCheckout";
var useExternalCheckout_default = useExternalCheckout;
export {
  useExternalCheckout_default as default,
  useExternalCheckout
};
